import { LARGER } from './breakpoint-controller'
let win , imageCtaCard, ctaCard , cardTitleHeight;
function onDocumentReady() {
    win = $(window)
    imageCtaCard = $('.layout-image-cta-card');
    ctaCard = imageCtaCard.find('.cta-card');

    ctaCard.each(function(){
        cardTitleHeight = $(this).find('.title').outerHeight() + 16;
         $(this).find('.content').css({ 'top': 'calc(100% - ' + cardTitleHeight+ 'px)' });
    });

    ctaCard.hover(
        function() {
            if(win.width() > LARGER){
                $(this).find('.content').css({ 'top': 0});
            }
        },
        function() {
            if(win.width() > LARGER){
                cardTitleHeight = $(this).find('.title').outerHeight() + 16;
                $(this).find('.content').css({ 'top': 'calc(100% - ' + cardTitleHeight+ 'px)' });
            }
        }
    );
}

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/image-cta-controller.js